import * as immer from 'immer';
import { Immer, produce } from 'immer';
import { freeze, noFunctions } from './helpers';

let produceNew = produce;

if (process.env.NODE_ENV !== 'production') {
  const { produce } = new Immer({
    onAssign(state, prop, value) {
      freeze(value);
      noFunctions(prop, value);
    },
  });

  produceNew = produce;
}

export default immer;
export { produceNew as produce };
